import {CookieConsent} from '../../../lib/localStorage/signUp/cookieConsent';

export function isCookieCategoriesChanged(
  previous?: CookieConsent['categories'],
  current?: CookieConsent['categories']
): boolean {
  if (!previous || !current) {
    return true;
  }

  return (
    previous.statistics !== current.statistics ||
    previous.marketing !== current.marketing
  );
}
